module.exports = __webpack_public_path__ + "assets/img/star.2d20590a.svg";